import Button, { EButtonVariant, EButtonColor, EButtonSize } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import { useCallback } from "react";
import VoteCard from "./VoteCard";
import { EVoteCardModal, useVoteCardModal } from "./VoteCardModal";
import CreateVoteModal from "./VoteCardModal/CreateVoteModal";
import DeleteVoteModal from "./VoteCardModal/DeleteVoteModal";
import { EQuestionCategory } from "common/enums/Project/Config/Vote/EQuestionCategory";
import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import { useVote } from "hooks/useVote";
import EditVoteModal from "./VoteCardModal/EditVoteModal";

export default function Votes() {
	const { project } = useProjectContext();
	const { generalVotes, fetchGeneralVotes } = useVote(project);
	const { selectedVote, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenDeleteModal } = useVoteCardModal();

	const onCreatedVote = useCallback(() => {
		fetchGeneralVotes();
		onCloseModal();
	}, [onCloseModal, fetchGeneralVotes]);

	const onEditedVote = useCallback(() => {
		fetchGeneralVotes();
		onCloseModal();
	}, [onCloseModal, fetchGeneralVotes]);

	const onDeletedVote = useCallback(() => {
		fetchGeneralVotes();
		onCloseModal();
	}, [onCloseModal, fetchGeneralVotes]);

	return (
		<div className={classes["root"]}>
			<div className={classes["title-container"]}>
				<Typography type="h3" weight="bold">
					{I18n.asset.pages.professional_space.tabs.votes.title}
				</Typography>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} size={EButtonSize.SMALL} onClick={onOpenCreateModal}>
					{I18n.asset.pages.professional_space.tabs.votes.create_vote}
				</Button>
			</div>
			<div className={classes["votes-container"]}>
				{generalVotes.map((voteWithResults) => (
					<div key={voteWithResults.question.id} className={classes["vote-card-container"]}>
						<VoteCard
							key={voteWithResults.question.id}
							voteWithResults={voteWithResults}
							onDeleteClick={() => onOpenDeleteModal(voteWithResults.question)}
							onEditClick={() => onOpenEditModal(voteWithResults.question)}
						/>
					</div>
				))}
			</div>

			{isModalOpen(EVoteCardModal.CREATE) && <CreateVoteModal category={EQuestionCategory.GENERAL} onCreated={onCreatedVote} onClose={onCloseModal} />}
			{isModalOpen(EVoteCardModal.EDIT) && selectedVote && <EditVoteModal vote={selectedVote} onEdited={onEditedVote} onClose={onCloseModal} />}
			{isModalOpen(EVoteCardModal.DELETE) && selectedVote && <DeleteVoteModal vote={selectedVote} onDelete={onDeletedVote} onClose={onCloseModal} />}
		</div>
	);
}
